import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconCrashed$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconCrashed extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '4156f9372e591fc2595baa3ae8920af795bea28f', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '9f9f5e243980aa4177f469987739cd76bafd680c', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'adc2fac4beccc50a539db3e50b58c05ff4e4fd8a', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M9.5 7a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m6 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m-7.72 7.67a.5.5 0 0 1-.46.33h-.68a.39.39 0 0 1-.4-.52 5 5 0 0 1 9.52 0 .39.39 0 0 1-.4.52h-.68a.5.5 0 0 1-.46-.33 3.47 3.47 0 0 0-6.44 0", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-crashed", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-crashed"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-crashed":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconCrashed$1);
            }
            break;
    } });
}

const CosmosIconCrashed = CosmosIconCrashed$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconCrashed, defineCustomElement };
